/**
 * Panier 2026 — Hedonist Labs
 * Complément au drawer natif (snippets/cart-drawer.liquid) : aucune dépendance, pas de jQuery.
 *
 *  - Filet de sécurité "ouverture après ajout" : intercepte toute réponse réussie vers
 *    /cart/add(.js) (fetch, XMLHttpRequest, $(document).ajaxSuccess si jQuery est présent),
 *    re-rend le drawer via le Section Rendering API (ou les `sections` déjà présentes dans la
 *    réponse) et l'ouvre. Débounce 600 ms pour ne pas doubler le travail des scripts existants
 *    (aqua-script.js / cw-script.js / product-form.js).
 *  - Code promo : POST /cart/update.js { discount } (fallback /discount/CODE), retrait des codes.
 *  - Cross-sell par règles ("Complétez votre commande", POST /cart/add.js avec sections, sélecteur de variante).
 *  - Robustesse : clic délégué sur #cart-icon-bubble (même si le header est remplacé par les
 *    scripts jQuery), synchronisation de la classe is-empty, restauration du libellé "Panier"
 *    du header après un re-rendu Dawn, Échap global, rafraîchissement au retour bfcache.
 *
 * cart-drawer.js / cart.js (Dawn) restent responsables de : ouverture/fermeture, focus trap,
 * quantité +/-, suppression, re-rendu après /cart/change.
 */
(function () {
  'use strict';

  if (window.HedonistCart2026) return;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var DEBOUNCE_MS = 600;
  var ADD_RE = /\/cart\/add(?:\.js)?(?:[?#]|$)/;
  var MUTATION_RE = /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:[?#]|$)/;

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function routes() {
    return window.routes || {};
  }

  function getDrawer() {
    return document.getElementById('mydiv') || document.querySelector('cart-drawer');
  }

  function getInner() {
    var drawer = getDrawer();
    return drawer ? drawer.querySelector('.drawer__inner') : null;
  }

  // Element porteur de l'état rendu (data-hc-count / data-hc-stamp / data-hc-announce), enfant de .drawer__inner :
  // il est remplacé à chaque re-rendu (Dawn ne remplace que l'innerHTML de .drawer__inner ou de #CartDrawer).
  function getState(scope) {
    var inner = scope || getInner();
    return inner ? inner.querySelector('[data-hc-stamp]') : null;
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* ------------------------------------------------------------------ rendu */

  function renderFromSections(sections) {
    if (!sections || !sections['cart-drawer']) return false;
    var inner = getInner();
    if (!inner) return false;

    var doc = parseHTML(sections['cart-drawer']);
    var newInner = doc.querySelector('.drawer__inner');
    if (!newInner) return false;

    var currentState = getState(inner);
    var newState = getState(newInner);
    var currentStamp = currentState ? currentState.getAttribute('data-hc-stamp') : null;
    var newStamp = newState ? newState.getAttribute('data-hc-stamp') : null;
    var sameState = !!currentStamp && currentStamp === newStamp;
    if (!sameState) {
      var ariaLabel = newInner.getAttribute('aria-label');
      if (ariaLabel) inner.setAttribute('aria-label', ariaLabel);
      var typedInput = inner.querySelector('.hc-discount__input');
      var typed = typedInput && typedInput.value;
      inner.innerHTML = newInner.innerHTML;
      var freshInput = typed ? inner.querySelector('.hc-discount__input') : null;
      if (freshInput && !freshInput.value) freshInput.value = typed;
    }

    if (!sameState && sections['cart-icon-bubble']) renderBubble(sections['cart-icon-bubble']);
    syncEmptyState();
    if (!sameState) announce();
    return true;
  }

  function renderBubble(html) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var doc = parseHTML(html);
    var source = doc.querySelector('.shopify-section') || doc.body;
    if (!source) return;
    bubble.innerHTML = source.innerHTML;
    restoreBubbleLabel();
  }

  function fetchSections() {
    return fetch(root() + '?sections=' + SECTIONS.join(','), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      hcSkipHook: true
    }).then(function (res) {
      if (!res.ok) throw new Error('sections ' + res.status);
      return res.json();
    });
  }

  function refresh(options) {
    var opts = options || {};
    var rendered = opts.sections ? renderFromSections(opts.sections) : false;
    var done = rendered ? Promise.resolve(true) : fetchSections().then(renderFromSections);
    return done
      .catch(function (err) {
        if (window.console && console.warn) console.warn('[cart-2026] refresh failed', err);
        return false;
      })
      .then(function (ok) {
        if (opts.open) openDrawer(opts.trigger || null);
        document.dispatchEvent(new CustomEvent('hc:cart:refreshed', { detail: { ok: ok, open: !!opts.open } }));
        return ok;
      });
  }

  var pending = null;
  var pendingTimer = null;

  function scheduleRefresh(options) {
    var opts = options || {};
    pending = pending || { open: false, sections: null, trigger: null };
    pending.open = pending.open || !!opts.open;
    // Toujours l'état le plus récent : un appel sans `sections` invalide celles reçues juste avant.
    pending.sections = opts.sections || null;
    if (opts.trigger) pending.trigger = opts.trigger;
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () {
      var job = pending;
      pending = null;
      refresh(job);
    }, DEBOUNCE_MS);
  }

  /* ------------------------------------------------------- état / a11y */

  function syncEmptyState() {
    var drawer = getDrawer();
    var state = getState();
    if (!drawer || !state) return;
    var count = state.getAttribute('data-hc-count');
    if (count === null) return;
    drawer.classList.toggle('is-empty', count === '0');
  }

  function announce() {
    var state = getState();
    var live = document.getElementById('CartDrawer-LiveRegionText');
    if (!state || !live) return;
    var text = state.getAttribute('data-hc-announce') || '';
    live.textContent = '';
    setTimeout(function () {
      live.textContent = text;
    }, 60);
  }

  function isOpen() {
    var drawer = getDrawer();
    return !!drawer && drawer.classList.contains('active');
  }

  // Verrou de défilement du body aligné sur la classe active, quel que soit le script qui l'a posée/retirée
  // (cart-drawer.js, scripts jQuery existants, ce fichier).
  var lastActive = null;

  function syncBodyLock() {
    var drawer = getDrawer();
    if (!drawer) return;
    var active = drawer.classList.contains('active');
    if (active === lastActive) return; // évite toute boucle observer -> classList -> observer
    lastActive = active;
    document.body.classList.toggle('overflow-hidden', active);
    if (active && !drawer.classList.contains('animate')) drawer.classList.add('animate');
  }

  function focusPanel(drawer) {
    var container = document.getElementById('CartDrawer') || drawer;
    var target = drawer.querySelector('.drawer__inner');
    if (typeof window.trapFocus === 'function' && container && target) {
      try {
        window.trapFocus(container, target);
        return;
      } catch (e) {
        /* ignore */
      }
    }
    if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
  }

  function openDrawer(trigger) {
    var drawer = getDrawer();
    if (!drawer) return;
    var activeEl = trigger || (document.activeElement && document.activeElement !== document.body ? document.activeElement : null);

    if (drawer.classList.contains('active')) {
      // Déjà ouvert (ex. scripts jQuery) : on complète ce qu'ils ne font pas.
      drawer.classList.add('animate');
      document.body.classList.add('overflow-hidden');
      if (activeEl && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(activeEl);
      focusPanel(drawer);
      return;
    }

    if (typeof drawer.open === 'function') {
      drawer.open(activeEl || undefined);
    } else {
      drawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      focusPanel(drawer);
    }
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('active')) return;
    if (typeof drawer.close === 'function') {
      drawer.close();
    } else {
      drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }

  /* ------------------------------------------- libellé "Panier" du header */

  var bubbleLabel = null;

  function bubbleLabelNode(bubble) {
    var spans = bubble.querySelectorAll(':scope > span:not(.visually-hidden)');
    return spans.length ? spans[spans.length - 1] : null;
  }

  function captureBubbleLabel() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var label = bubbleLabelNode(bubble);
    if (label) bubbleLabel = label.cloneNode(true);
  }

  function restoreBubbleLabel() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    if (!bubble.getAttribute('role')) bubble.setAttribute('role', 'button');
    if (!bubble.getAttribute('aria-haspopup')) bubble.setAttribute('aria-haspopup', 'dialog');
    if (bubbleLabel && !bubbleLabelNode(bubble)) bubble.appendChild(bubbleLabel.cloneNode(true));
  }

  /* ------------------------------------------------------------- hooks */

  function handleMutationResponse(url, getJson) {
    var isAdd = ADD_RE.test(url);
    getJson()
      .then(function (json) {
        scheduleRefresh({ open: isAdd, sections: json && json.sections ? json.sections : null });
      })
      .catch(function () {
        scheduleRefresh({ open: isAdd });
      });
  }

  function hookFetch() {
    if (typeof window.fetch !== 'function' || window.fetch.__hcHooked) return;
    var original = window.fetch;
    var wrapped = function (input, init) {
      var promise = original.apply(this || window, arguments);
      try {
        if (init && init.hcSkipHook) return promise;
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && MUTATION_RE.test(url)) {
          promise
            .then(function (res) {
              if (!res || !res.ok) return;
              handleMutationResponse(url, function () {
                return res.clone().json();
              });
            })
            .catch(function () {
              /* l'appelant gère ses propres erreurs */
            });
        }
      } catch (e) {
        /* jamais bloquer fetch */
      }
      return promise;
    };
    wrapped.__hcHooked = true;
    window.fetch = wrapped;
  }

  function hookXHR() {
    var proto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (!proto || proto.__hcHooked) return;
    var open = proto.open;
    var send = proto.send;
    proto.open = function (method, url) {
      try {
        this.__hcMethod = String(method || 'GET').toUpperCase();
        this.__hcUrl = String(url || '');
      } catch (e) {
        /* ignore */
      }
      return open.apply(this, arguments);
    };
    proto.send = function () {
      try {
        if (this.__hcMethod === 'POST' && MUTATION_RE.test(this.__hcUrl || '')) {
          var xhr = this;
          xhr.addEventListener('load', function () {
            if (xhr.status < 200 || xhr.status >= 300) return;
            handleMutationResponse(xhr.__hcUrl, function () {
              return new Promise(function (resolve, reject) {
                try {
                  if (xhr.responseType === 'json') resolve(xhr.response);
                  else if (!xhr.responseType || xhr.responseType === 'text') resolve(JSON.parse(xhr.responseText));
                  else reject(new Error('non-text response'));
                } catch (e) {
                  reject(e);
                }
              });
            });
          });
        }
      } catch (e) {
        /* ignore */
      }
      return send.apply(this, arguments);
    };
    proto.__hcHooked = true;
  }

  function hookJQuery() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$(document).ajaxSuccess) return;
    $(document).ajaxSuccess(function (event, xhr, settings) {
      try {
        var url = (settings && settings.url) || '';
        var method = ((settings && (settings.type || settings.method)) || 'GET').toUpperCase();
        if (method === 'POST' && MUTATION_RE.test(url)) {
          scheduleRefresh({ open: ADD_RE.test(url) });
        }
      } catch (e) {
        /* ignore */
      }
    });
  }

  /* --------------------------------------------------------- requêtes */

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      hcSkipHook: true
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return null;
        })
        .then(function (json) {
          return { ok: res.ok, status: res.status, json: json };
        });
    });
  }

  function updateUrl() {
    return routes().cart_update_url || root() + 'cart/update.js';
  }

  function addUrl() {
    return routes().cart_add_url || root() + 'cart/add.js';
  }

  /* ------------------------------------------------------- code promo */

  function discountBox() {
    var inner = getInner();
    return inner ? inner.querySelector('.hc-discount') : null;
  }

  function currentCodes() {
    var box = discountBox();
    var raw = box ? box.getAttribute('data-hc-codes') || '' : '';
    return raw
      .split(',')
      .map(function (c) {
        return c.trim();
      })
      .filter(Boolean);
  }

  function sameCode(a, b) {
    return String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
  }

  function setDiscountBusy(busy) {
    var box = discountBox();
    if (!box) return;
    box.classList.toggle('is-busy', busy);
    box.querySelectorAll('button').forEach(function (button) {
      if (busy) button.setAttribute('disabled', 'disabled');
      else button.removeAttribute('disabled');
    });
    var input = box.querySelector('.hc-discount__input');
    if (input) input.readOnly = busy;
  }

  function showDiscountError(message) {
    var box = discountBox();
    var el = box ? box.querySelector('.hc-discount__error') : null;
    if (el) el.textContent = message || '';
  }

  function focusDiscountInput(selectAll) {
    var box = discountBox();
    var input = box ? box.querySelector('.hc-discount__input') : null;
    if (!input) return;
    input.focus();
    if (selectAll && input.value) input.select();
  }

  function codeStatus(cart, code) {
    if (cart && Array.isArray(cart.discount_codes)) {
      var match = cart.discount_codes.filter(function (entry) {
        return entry && sameCode(entry.code, code);
      })[0];
      return match && match.applicable ? 'applied' : 'invalid';
    }
    // Repli : lecture des codes appliqués dans le rendu Liquid (data-hc-codes).
    var html = cart && cart.sections && cart.sections['cart-drawer'];
    if (html) {
      var box = parseHTML(html).querySelector('.hc-discount');
      var codes = box ? (box.getAttribute('data-hc-codes') || '').split(',') : [];
      if (
        codes.some(function (c) {
          return c && sameCode(c, code);
        })
      ) {
        return 'applied';
      }
    }
    return 'invalid';
  }

  function fallbackDiscountRedirect(code) {
    var redirect = routes().cart_url || root() + 'cart';
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
  }

  function applyDiscount(form) {
    var input = form.querySelector('input[name="discount"]');
    var code = input ? input.value.trim() : '';
    var errorText = form.getAttribute('data-hc-error-text') || 'Code invalide';
    if (!code) {
      focusDiscountInput(false);
      return;
    }

    var previous = currentCodes();
    var next = previous
      .filter(function (c) {
        return !sameCode(c, code);
      })
      .concat([code]);

    showDiscountError('');
    setDiscountBusy(true);

    postCart(updateUrl(), { discount: next.join(','), sections: SECTIONS, sections_url: root() })
      .then(function (result) {
        if (!result.ok || !result.json) {
          fallbackDiscountRedirect(code);
          return;
        }
        var cart = result.json;
        var status = codeStatus(cart, code);
        if (status === 'applied') {
          if (input) input.value = '';
          if (!renderFromSections(cart.sections)) return fetchSections().then(renderFromSections);
          return true;
        }
        // Code refusé : on rétablit l'état précédent (retire le code non applicable) puis on affiche l'erreur.
        return postCart(updateUrl(), { discount: previous.join(','), sections: SECTIONS, sections_url: root() })
          .then(function (cleanup) {
            if (cleanup.json && cleanup.json.sections) renderFromSections(cleanup.json.sections);
          })
          .catch(function () {
            /* ignore */
          })
          .then(function () {
            var freshInput = discountBox() && discountBox().querySelector('.hc-discount__input');
            if (freshInput) freshInput.value = code;
            showDiscountError(errorText);
            focusDiscountInput(true);
          });
      })
      .catch(function () {
        showDiscountError(errorText);
      })
      .then(function () {
        setDiscountBusy(false);
      });
  }

  function removeDiscount(code) {
    var remaining = currentCodes().filter(function (c) {
      return !sameCode(c, code);
    });
    showDiscountError('');
    setDiscountBusy(true);
    postCart(updateUrl(), { discount: remaining.join(','), sections: SECTIONS, sections_url: root() })
      .then(function (result) {
        if (result.json && renderFromSections(result.json.sections)) return true;
        return fetchSections().then(renderFromSections);
      })
      .catch(function () {
        /* ignore */
      })
      .then(function () {
        setDiscountBusy(false);
      });
  }

  /* ------------------------------------------------------------ cross-sell */

  // Le <select> de variante (produit multi-variantes) est hors <cart-drawer-items> : son événement change
  // n'atteint pas cart.js. Il met à jour le prix affiché et la variante ciblée par le bouton « Ajouter ».
  function onCrossSellVariantChange(select) {
    var card = select.closest('.hc-xsell__item');
    if (!card) return;
    var option = select.options[select.selectedIndex];
    var button = card.querySelector('[data-hc-xsell-add]');
    var price = card.querySelector('[data-hc-xsell-price]');
    if (button && option) button.setAttribute('data-hc-xsell-add', option.value);
    if (price && option && option.getAttribute('data-hc-price-html')) price.innerHTML = option.getAttribute('data-hc-price-html');
  }

  function addCrossSell(button) {
    var card = button.closest('.hc-xsell__item');
    var select = card ? card.querySelector('[data-hc-xsell-select]') : null;
    var variantId = parseInt((select && select.value) || button.getAttribute('data-hc-xsell-add'), 10);
    if (!variantId || button.hasAttribute('disabled')) return;
    button.setAttribute('disabled', 'disabled');
    var errors = document.getElementById('CartDrawer-CartErrors');
    if (errors) errors.textContent = '';

    postCart(addUrl(), { items: [{ id: variantId, quantity: 1 }], sections: SECTIONS, sections_url: root() })
      .then(function (result) {
        if (!result.ok) {
          var message = (result.json && (result.json.description || result.json.message)) || (window.cartStrings && window.cartStrings.error) || '';
          if (errors) errors.textContent = message;
          button.removeAttribute('disabled');
          return;
        }
        if (!renderFromSections(result.json && result.json.sections)) return fetchSections().then(renderFromSections);
      })
      .catch(function () {
        if (errors && window.cartStrings) errors.textContent = window.cartStrings.error || '';
        button.removeAttribute('disabled');
      });
  }

  /* ------------------------------------------------------------ événements */

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var cartLink = target.closest('#cart-icon-bubble');
      if (cartLink) {
        // cart-drawer.js gère déjà le clic (preventDefault) tant que l'élément d'origine existe ;
        // si le header a été remplacé (scripts jQuery), on prend le relais.
        if (!event.defaultPrevented) {
          event.preventDefault();
          openDrawer(cartLink);
        }
        return;
      }

      if (target.closest('[data-hc-close]') || target.closest('#CartDrawer-Overlay')) {
        // Le onclick inline / cart-drawer.js ferment déjà ; closeDrawer() est sans effet si déjà fermé.
        closeDrawer();
        return;
      }

      var removeCode = target.closest('[data-hc-remove-code]');
      if (removeCode) {
        event.preventDefault();
        removeDiscount(removeCode.getAttribute('data-hc-remove-code') || '');
        return;
      }

      var crossSell = target.closest('[data-hc-xsell-add]');
      if (crossSell) {
        event.preventDefault();
        addCrossSell(crossSell);
      }
    });

    document.addEventListener('change', function (event) {
      var select = event.target;
      if (select instanceof Element && select.hasAttribute('data-hc-xsell-select')) onCrossSellVariantChange(select);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof Element) || !form.hasAttribute('data-hc-discount-form')) return;
      event.preventDefault();
      applyDiscount(form);
    });

    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape' && event.code !== 'Escape') return;
      var drawer = getDrawer();
      if (!drawer || !drawer.classList.contains('active')) return;
      // Focus dans le drawer : cart-drawer.js s'en charge déjà.
      if (drawer.contains(event.target)) return;
      closeDrawer();
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) scheduleRefresh({ open: false });
    });

    // Garde-fou : la zone défilante ne doit jamais glisser horizontalement (un focus() posé par cart.js
    // après un re-rendu peut faire défiler un conteneur overflow-x:hidden si un élément déborde).
    document.addEventListener(
      'scroll',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element) || !target.classList.contains('hc-scroll')) return;
        if (target.scrollLeft) target.scrollLeft = 0;
      },
      true
    );
  }

  function observe() {
    if (!window.MutationObserver) return;

    var drawerRoot = document.getElementById('CartDrawer');
    if (drawerRoot) {
      new MutationObserver(function () {
        syncEmptyState();
      }).observe(drawerRoot, { childList: true, subtree: true });
    }

    var drawer = getDrawer();
    if (drawer) {
      new MutationObserver(function () {
        syncBodyLock();
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && bubble.parentNode) {
      new MutationObserver(function () {
        restoreBubbleLabel();
      }).observe(bubble.parentNode, { childList: true, subtree: true });
    }
  }

  function init() {
    hookFetch();
    hookXHR();
    hookJQuery();
    captureBubbleLabel();
    observe();
    bindEvents();
    syncEmptyState();
  }

  window.HedonistCart2026 = {
    open: function (trigger) {
      openDrawer(trigger || null);
    },
    close: closeDrawer,
    refresh: function (open) {
      return refresh({ open: !!open });
    },
    isOpen: isOpen
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
